var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1qEb41-oC_NOkA{background-color:#e4f0f6;display:grid;height:48px;grid-template-columns:auto 1fr auto;align-items:center;grid-gap:12px;padding-right:48px}._1qEb41-oC_NOkA._1yTdjCjpSh6XUn,._1qEb41-oC_NOkA.FumqRW-j2V4xGV{padding-right:8px}._1qEb41-oC_NOkA ._1UGxdKpRGuKdJr{background-image:url(" + escape(require("resources/images/card-templates/header-card-template.png")) + ");height:48px;width:72px;background-size:cover}._1qEb41-oC_NOkA ._1MArJ6SJ1RCwcD{font-size:16px;line-height:30px;margin:0}._1qEb41-oC_NOkA ._1Mqt_HS_XzFzAM{margin-bottom:0}._11AuPRs48e4Srr{margin:0 12px}", ""]);

// exports
exports.locals = {
	"templateCardBanner": "_1qEb41-oC_NOkA",
	"hasStickers": "FumqRW-j2V4xGV",
	"hasCover": "_1yTdjCjpSh6XUn",
	"templateCardBannerImage": "_1UGxdKpRGuKdJr",
	"templateCardBannerText": "_1MArJ6SJ1RCwcD",
	"templateCardBannerButton": "_1Mqt_HS_XzFzAM",
	"popoverPadding": "_11AuPRs48e4Srr"
};